import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { StateService } from './state.service'

const districtsList = [
  'Kalangala',
  'Buikwe',
  'Buvuma',
  'Namayingo',
  'Katakwi',
  'Nakapiripirit',
  'Kamwenge',
  'Mbarara',
  'Kotido',
  'Agago',
  'Bulambuli',
  'Kween',
  'Amudat',
  'Kaberamaido',
  'Amolatar',
  'Kaliro',
  'Namutumba',
  'Kitgum',
  'Lamwo',
  'Pader',
  'Sironko',
  'Mbale',
  'Bugiri',
  'Busia',
  'Butaleja',
  'Mayuge',
  'Manafwa',
  'Tororo',
  'Masaka',
  'Kasese',
  'Ntungamo',
  'Bushenyi',
  'Rukungiri',
  'Ibanda',
  'Mbararaa',
  'Kabale',
  'Kanungu',
  'Nebbi',
  'Zombo',
  'Ngora',
  'Bukedea',
  'Budaka',
  'Kibuku',
  'Pallisa',
  'Serere',
  'Kalungu',
  'Gomba',
  'Amuru',
  'Amuria',
  'Otuke',
  'Oyam',
  'Kiryandongo',
  'Kibale',
  'Ntoroko',
  'Kyegegwa',
  'Napak',
  'Moroto',
  'Bukwa',
  'Bukomansimbi',
  'Lwengo',
  'Lyantonde',
  'Butambala',
  'Rubirizi',
  'Sheema',
  'Mitooma',
  'Buhweju',
  'Bududa',
  'Jinja',
  'Kayunga',
  'Iganga',
  'Alebtong',
  'Soroti',
  'Buyende',
  'Kumi',
  'Mpigi',
  'Adjumani',
  'Yumbe',
  'Kampala',
  'Mukono',
  'Wakiso',
  'Sembabule',
  'Mityana',
  'Nakaseke',
  'Dokolo',
  'Lira',
  'Gulu',
  'Nwoya',
  'Masindi',
  'Apac',
  'Buliisa',
  'Hoima',
  'Kabarole',
  'Kapchorwa',
  'Kaabong',
  'Abim',
  'Rakai',
  'Isingiro',
  'Kisoro',
  'Luuka',
  'Kamuli',
  'Arua',
  'Koboko',
  'Moyo',
  'Luweero',
  'Mubende',
  'Nakasongola',
  'Bundibugyo',
  'Kyankwanzi',
  'Kole',
  'Maracha',
  'Kiboga',
  'Kyenjojo',
]
const initialState = {
  districts: [],
}

@Injectable({
  providedIn: 'root',
})
export class LocationStateService extends StateService<any> {
  disticts$: Observable<{ label: string; value: string }[]> = this.select(
    (state) => state.districts
  )
  constructor() {
    super(initialState)
    this.getDistrictData()
  }

  getDistrictData() {
    const districts = this.addLabels(districtsList)

    this.setState({ districts })
  }

  addLabels(data: any[], key = null) {
    return data.map((val) => ({ label: val, value: val }))
  }
}
